import { Select } from "@mui/material";
import MenuItemWithoutHighlight from "@entrilia/shared/components/MenuItemWithoutHighlight";
import PortalPageStatusChip from "./PortalPageStatusChip";
import type { PortalPageStatus } from "./portalPageStatusHelper";
import { allPortalPageStatuses } from "./portalPageStatusHelper";

interface Props {
  value: PortalPageStatus;
  onChange: (newValue: PortalPageStatus) => void;
}

const PortalPageStatusSelect = ({ value, onChange }: Props) => {
  return (
    <Select
      variant="standard"
      disableUnderline
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        ".MuiInputBase-input": {
          "&:focus": {
            backgroundColor: "transparent",
          },
        },
      }}
    >
      {allPortalPageStatuses.map((status) => (
        <MenuItemWithoutHighlight key={status} value={status}>
          <PortalPageStatusChip value={status} />
        </MenuItemWithoutHighlight>
      ))}
    </Select>
  );
};

export default PortalPageStatusSelect;
